export const copyToClipboard = (content) => {
	try {
		navigator.clipboard.writeText(content);
	} catch (error) {}
};
